module.exports = __webpack_public_path__ + "static/media/33.3ddeebae.mp3";